import { graphql } from "react-relay";

export const COMMIT_PLAYER_CHANGES = graphql`
  mutation CommitPlayerSelectionChangesMutation(
    $input: CommitPlayerSelectionChangesInput!
  ) {
    commitPlayerSelectionChanges(input: $input) {
      success
    }
  }
`;
